import { Map } from "maplibre-gl";
import { boundsForList } from "../map/util";

// Ruimte rond de inhoud; de globale fitBounds() in map/util rekent met het
// rapportpaneel links en klopt in de workspace niet.
export const FIT_PADDING = { top: 40, bottom: 40, left: 40, right: 40 };

export const fitToParcels = (map?: Map, parcels: any[] = []) => {
  if (!map || !parcels.length) return false;
  const bounds = boundsForList(parcels);
  if (bounds.isEmpty()) return false;
  map.fitBounds(bounds, { padding: FIT_PADDING, maxZoom: 16 });
  return true;
};
